<template>
<div class="flex flex-col gap-5">
  <div>
    <V3StoreComponentInfo :data="data" lines="5"/>
  </div>
  <div>
    <UDivider/>
  </div>
  <div>
    <p class="text-gray-700 dark:text-gray-400 line-clamp-5">{{ data.detail.description }}</p>
  </div>
  <div>
    <UDivider/>
  </div>
  <div>
    <table class="w-full mt-1">
      <tbody class="">
        <tr>
          <th class="text-left py-2 text-gray-700 dark:text-gray-400 text-nowrap">Seller NP</th>
          <td class="px-4 break-all">{{ data.seller_id }}</td>
        </tr>
        <tr>
          <th class="text-left py-2 text-gray-700 dark:text-gray-400 text-nowrap">Provider ID</th>
          <td class="px-4 break-all">{{ data.id }}</td>
        </tr>
        <tr>
          <th class="text-left py-2 text-gray-700 dark:text-gray-400 text-nowrap">Category</th>
          <td class="px-4 break-normal">{{ data.categories.join(", ") }}</td>
        </tr>
        <tr v-if="isFandB && data.fssai_number">
          <th class="text-left py-2 text-gray-700 dark:text-gray-400 text-nowrap">FSSAI Number</th>
          <td class="px-4 break-all">{{ data.fssai_number }}</td>
        </tr>
        <tr v-if="isServiceabilityValid(data)">
          <th class="text-left py-2 text-gray-700 dark:text-gray-400 text-nowrap">Servicing distance</th>
          <td class="px-4 break-all">{{ getServiceability(data) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script setup>
const props = defineProps(['data']);
const isFandB = props.data.categories[0]?.toUpperCase() === 'F&B';

const isServiceabilityValid = (data) => {
  if (!data?.tags || !Array.isArray(data.tags)) return false;
  const serviceability = data.tags.find(tag => tag.code === "serviceability");
  if (!serviceability) return false;
  const valItem = serviceability.list.find(item => item.code === "val");
  const unitItem = serviceability.list.find(item => item.code === "unit");
  return (
    valItem &&
    unitItem &&
    isNumeric(valItem.value) &&
    valItem.value &&
    unitItem.value
  );
};

const isNumeric = (value) => {
  if (typeof value === "number") {
    return !isNaN(value);
  }
  if (typeof value === "string") {
    return !isNaN(parseFloat(value)) && isFinite(value); 
  }
  return false;
};

const getServiceability = (data) => {
  if (!Array.isArray(data.tags) || data.tags.length === 0) {
    return 'Invalid data structure: No tags found';
  }
  const serviceability = data.tags.find(tag => tag.code === "serviceability");
  if (!serviceability) {
    return 'Serviceability tag not found';
  }
  if (!Array.isArray(serviceability.list) || serviceability.list.length === 0) {
    return 'Invalid serviceability list data';
  }
  const valItem = serviceability.list.find(item => item.code === "val");
  const unitItem = serviceability.list.find(item => item.code === "unit");
  if (!valItem || !unitItem) {
    return 'Missing required "val" or "unit" data in serviceability';
  }
  let val = valItem.value;
  const unit = unitItem.value;
  if (!val || !unit || isNaN(val)) {
    return 'Invalid value or unit data';
  }
  val = Math.floor(parseFloat(val) * 10) / 10;
  return `Upto ${val} ${unit}`;
}

</script>
